module.exports = __webpack_public_path__ + "static/bane-DND3_FnP-90bf7626e649c64c288fc5dd31c39d2d.webp";